import { validThemes } from "../../config/constants";
export const validateThemeValue = (theme: string) => {
    return validThemes.includes(theme);
};